<script>
import Chat from './Chat.vue';
import OpenButton from './OpenButton.vue';

export default {
    name: 'AiTutor',
    components: {
        OpenButton,
        Chat
    },
    props: {
        config: Object,
        fullname: String,
        username: String,
        grade: {
            default() {
                return null
            }
        },
        metadata: {
            default() {
                return {}
            }
        },
        fullscreen: {
            default() {
                return false
            }
        }
    },
    data() {
        return {
            isConnected: window.boChatbot ? true : false,
            isOpen: false,
            currentSession: '',
            sessions: [],
            messages: [],
            isSending: false,
            usage: {
                daily: 0,
                weekly: 0,
                monthly: 0,
                yearly: 0
            },
            partnerConfig: null
        }
    },
    created() {
        if (!this.fullname || !this.username) return;

        if (typeof window !== 'undefined') {
            const scriptSrc = `${process.env.VUE_APP_CHATBOT_SCRIPT}&enable_sdk=1&disable_action=1&sync_chat=1&mode=background`
            // Check if the script already exists before inserting
            if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
                const script = document.createElement('script');
                script.src = scriptSrc;
                document.body.appendChild(script);
            }
        }

        window.addEventListener('BO_CHATBOT_CONNECTED', (data) => {
            this.isConnected = true
            this.partnerConfig = data.detail?.partnerConfig
            window.boChatbot?.startConversation(this.fullname, this.username)
            window.boChatbot?.setContext('grade', this.grade)

            // setup initial context
            for (const key in this.metadata) {
                window.boChatbot?.setContext(key, this.metadata[key])
            }

            // Register a handler for incoming messages from chatbot
            window.addEventListener(window.boChatbot?.events.UPDATE_CHAT_HISTORY, (payload) => {
                this.currentSession = payload.detail.currentSession
                this.sessions = payload.detail.sessions
                this.messages = payload.detail.messages
                this.usage = {
                    daily: payload.detail.dailyUsage,
                    weekly: payload.detail.weeklyUsage,
                    monthly: payload.detail.monthlyUsage,
                    yearly: payload.detail.yearlyUsage
                }
            })

            window.addEventListener(window.boChatbot?.events.SEND_MESSAGE, () => {
                this.isSending = true
            })

            window.addEventListener(window.boChatbot?.events.RESPONE_MESSAGE_AI, () => {
                this.isSending = false
            })
        }, { once: true })
    },
    methods: {
        handleOpenChat() {
            this.isOpen = true
        },
        handleCloseChat() {
            this.isOpen = false
            this.isSending = false
        }
    }
}
</script>

<template>
    <div v-if="isConnected">
        <open-button v-if="!isOpen && !fullscreen" @open="handleOpenChat" />
        <chat v-else :featureConfig="config" :partner-config="partnerConfig" :usage="usage" :fullname="fullname"
            :username="username" :current-session="currentSession" :sessions="sessions" :messages="messages"
            @close="handleCloseChat" :is-sending="isSending" :is-fullscreen="fullscreen" />
    </div>
</template>